import { PortfolioTopTenHoldingMoneyFunds } from '@models';
import {
  ConfigurationCountry,
  ConfigurationLocale,
  FundId,
  PortfolioTopTenHoldingMoneyFundsDTO,
} from '@types';
import { MapperFactory } from '../mapper-factory';
import { Mapper, MapperParams } from '../type.mapper';

export class TopTenHoldingsMoneyFundsMapper extends Mapper<
  PortfolioTopTenHoldingMoneyFunds[]
> {
  constructor(mapperParams: MapperParams, mapperFactory: MapperFactory) {
    super(mapperParams, mapperFactory);
  }

  toDomain(
    portfolioTopTenHoldingsMoneyFundsDTO: PortfolioTopTenHoldingMoneyFundsDTO[]
  ): PortfolioTopTenHoldingMoneyFunds[] {
    const portfolioTopTenHoldingsMoneyFunds: PortfolioTopTenHoldingMoneyFunds[] = [];

    if (Array.isArray(portfolioTopTenHoldingsMoneyFundsDTO)) {
      portfolioTopTenHoldingsMoneyFundsDTO.forEach(
        (
          portfolioTopTenHoldingMoneyFundsDTO: PortfolioTopTenHoldingMoneyFundsDTO
        ) => {
          const portfolioTopTenHoldingMoneyFunds: PortfolioTopTenHoldingMoneyFunds = this.createMapper(
            TopTenHoldingMoneyFundsMapper
          ).toDomain(portfolioTopTenHoldingMoneyFundsDTO);

          if (portfolioTopTenHoldingMoneyFunds) {
            portfolioTopTenHoldingsMoneyFunds.push(
              portfolioTopTenHoldingMoneyFunds
            );
          }
        }
      );
    }

    return portfolioTopTenHoldingsMoneyFunds;
  }
}

export class TopTenHoldingMoneyFundsMapper extends Mapper<PortfolioTopTenHoldingMoneyFunds> {
  constructor(mapperParams: MapperParams, mapperFactory: MapperFactory) {
    super(mapperParams, mapperFactory);
  }

  toDomain(
    portfolioTopTenHoldingMoneyFundsDTO: PortfolioTopTenHoldingMoneyFundsDTO
  ): PortfolioTopTenHoldingMoneyFunds {
    return {
      fundId: portfolioTopTenHoldingMoneyFundsDTO.fundid as FundId,
      countryCode: portfolioTopTenHoldingMoneyFundsDTO.cntrycode as ConfigurationCountry,
      languageCode: portfolioTopTenHoldingMoneyFundsDTO.langcode as ConfigurationLocale,
      asOfDate: portfolioTopTenHoldingMoneyFundsDTO.asofdate,
      asOfDateStd: portfolioTopTenHoldingMoneyFundsDTO.asofdatestd,
      updateFrequency: portfolioTopTenHoldingMoneyFundsDTO.frequency,
      securityName: portfolioTopTenHoldingMoneyFundsDTO.securityname,
      countryOfIssue: portfolioTopTenHoldingMoneyFundsDTO.cntryofissue,
      holdingValue: portfolioTopTenHoldingMoneyFundsDTO.hldngvalue,
      holdingValueStd: portfolioTopTenHoldingMoneyFundsDTO.hldngvaluestd,
      maturityDate: portfolioTopTenHoldingMoneyFundsDTO.maturitydate,
      maturityDateStd: portfolioTopTenHoldingMoneyFundsDTO.maturitydatestd,
      assetType: portfolioTopTenHoldingMoneyFundsDTO.assettype,
      assetTypeStd: portfolioTopTenHoldingMoneyFundsDTO.assettypestd,
    };
  }
}
